import { render } from "./HistoryClaimComponent.vue?vue&type=template&id=41191be6&scoped=true"
import script from "./HistoryClaimComponent.vue?vue&type=script&lang=js"
export * from "./HistoryClaimComponent.vue?vue&type=script&lang=js"

import "./HistoryClaimComponent.vue?vue&type=style&index=0&id=41191be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41191be6"]])

export default __exports__